'use strict';

const $giftcardTrigger = $('.js-giftcard-trigger');
const $paymentMethodContainer = $('.containerGiftcards');
const $Add_Button = $('.giftcard-container .add');
const $Remove_Button = $('.giftcard-container .remove');
const $giftcard_infobox_on_cart = $('.giftcard_infobox');

function validateGiftCard() {
  return true;
}

function getMerchandizeTotalPrice () {
  const val = $paymentMethodContainer.attr('data-merchandizetotalprice');
  return typeof val === "string" ? parseFloat(val) : val;
}

function getGiftCardNumberOnSession () {
  const stringObject = $paymentMethodContainer.attr('data-giftcardnumberonsession');
  let _array_ = [];
  if (stringObject && stringObject !== null && stringObject !== 'null') {
    try { 
      _array_ = typeof stringObject === "string"
      ? stringObject.indexOf('[') !== -1
      ? JSON.parse(stringObject)
      : stringObject.split(',')
      : stringObject;
    } catch (err) {}
  }
  return _array_;
}

function setGiftCardNumberOnSession (arrayString) {
  $paymentMethodContainer.attr('data-giftcardnumberonsession', arrayString);
}

function isMixablePaymentInstruments() {
  const val = $paymentMethodContainer.attr('data-mixablepaymentinstruments');
  return val === true || val === "true";
}

function setMixablePaymentInstruments (status) {
  $paymentMethodContainer.attr('data-mixablepaymentinstruments', status);
}

function getRemaining () {
  const val = $paymentMethodContainer.attr('data-remaining');
  return typeof val === "string" ? parseFloat(val) : val;
}

function setRemaining (number) {
  $paymentMethodContainer.attr('data-remaining', number);
}

function getGiftcardError () {
  return $paymentMethodContainer.attr('data-giftcarderror');
}

function setGiftcardError (value) {
  $paymentMethodContainer.attr('data-giftcarderror', value);
}

function getTotals_GiftcardPaymentInstruments_Amount () {
  const val = $paymentMethodContainer.attr('data-totalsgiftcardpaymentinstrumentsamount');
  return typeof val === "string" ? parseFloat(val) : val;
}

function setTotals_GiftcardPaymentInstruments_Amount (number) {
  $paymentMethodContainer.attr('data-totalsgiftcardpaymentinstrumentsamount', number);
}

function getTotals_OtherPaymentInstruments_Amount () {
  const val = $paymentMethodContainer.attr('data-totalsotherpaymentinstrumentsamount');
  return typeof val === "string" ? parseFloat(val) : val;
}

function setTotals_OtherPaymentInstruments_Amount (number) {
  $paymentMethodContainer.attr('data-totalsotherpaymentinstrumentsamount', number);
}


function thereAreGiftcardOnCart() {
  var giftCardNumberOnSession = getGiftCardNumberOnSession();
  if (!giftCardNumberOnSession || !giftCardNumberOnSession.length) {
    return false;
  }
  try {
    return giftCardNumberOnSession.length;
  } catch (err) {
    return false;
  }
}

function Update_AttributeData ({
  trigger__Refresh_GiftCards,
  giftcardnumberonsession,
  mixablepaymentinstruments,
  remaining,
  giftcarderror,
  totalsgiftcardpaymentinstrumentsamount,
  totalsotherpaymentinstrumentsamount
}) {
  if (remaining !== null) {
    setRemaining(remaining)
  }
  if (giftcarderror !== null) {
    setGiftcardError(giftcarderror)
  }
  if (totalsgiftcardpaymentinstrumentsamount !== null) {
    setTotals_GiftcardPaymentInstruments_Amount(totalsgiftcardpaymentinstrumentsamount)
  }
  if (totalsotherpaymentinstrumentsamount !== null) {
    setTotals_OtherPaymentInstruments_Amount(totalsotherpaymentinstrumentsamount)
  }
  if (giftcardnumberonsession !== null) {
    setGiftCardNumberOnSession(giftcardnumberonsession);
    if (trigger__Refresh_GiftCards) {
      Refresh_GiftCards()
    }
  }
  if (mixablepaymentinstruments !== null) {
    setMixablePaymentInstruments(mixablepaymentinstruments);
    Refresh_PaymentMethods();
  }
}

function Refresh_GiftCards () {
  var giftCardNumberOnSession = getGiftCardNumberOnSession()

  if (!giftCardNumberOnSession || !giftCardNumberOnSession.length) {
    const $allGiftcardContainer = $paymentMethodContainer.find(`ul .giftcard-container.paymentMethod.added`);
    $allGiftcardContainer.removeClass('added');
  }

  giftCardNumberOnSession.map((serial) => {
    const $giftcardContainer = $paymentMethodContainer.find(`ul .giftcard-container[data-serial="${serial}"]`);
    if (giftCardNumberOnSession.length && giftCardNumberOnSession.includes(serial)) {
      $giftcardContainer.addClass('added');
    } else {
      $giftcardContainer.removeClass('added');
    }
  })
}

function disableOtherPayments() {
  Active_GiftCertificate_PaymentMethod();
  $('#paymentMethodsList .paymentMethod').addClass('disabled');
  $('.credit-card-selection-new .paymentMethod:not(.giftcard):not(.giftcard-container)').addClass('disabled');
}

function enableMixedpayments(all) {
  Active_FirstOther_PaymentMethod();
  let allowedPayments = $('#paymentMethodsList').data('paymentmethodswithgc').split('|');
  let paymentMethodsEl = $('.paymentMethod');
  let mixedPayments;
  allowedPayments.forEach(function (payment) {
    mixedPayments = paymentMethodsEl.filter(function (index, el) {
      return $(el).hasClass('paymentMethod-' + payment);
    });
    if (all) {
      mixedPayments = paymentMethodsEl;
    }
    mixedPayments.each(function (e, el) {
      $(el).removeClass('disabled');
    });
  });
}

function displayMessage(Response_Messages) {
  if (!Response_Messages) {
    return;
  }
  $giftcard_infobox_on_cart.find('#message_action').html(Response_Messages.ACTION)
  $giftcard_infobox_on_cart.find('#message_action').removeClass()
  if (Response_Messages.ACTION_class) {
    $giftcard_infobox_on_cart.find('#message_action').addClass(Response_Messages.ACTION_class)
  }
  $giftcard_infobox_on_cart.find('#message_status').html(Response_Messages.STATUS)
  $giftcard_infobox_on_cart.find('#message_details').html(Response_Messages.DETAILS)
}

function Refresh_PaymentMethods (fromTrigger) {

  disableOtherPayments();

  const MerchandizeTotalPrice = getMerchandizeTotalPrice();
  const Remaining = getRemaining();
  const Totals_GiftcardPaymentInstruments_Amount = getTotals_GiftcardPaymentInstruments_Amount();
  const Totals_OtherPaymentInstruments_Amount = getTotals_OtherPaymentInstruments_Amount();
  const Payment_Totals = Totals_GiftcardPaymentInstruments_Amount + Totals_OtherPaymentInstruments_Amount;
  const Payment_Incomplete_with_GC = !!Remaining && !!Totals_GiftcardPaymentInstruments_Amount && !Totals_OtherPaymentInstruments_Amount;
  const Payment_Complete = Payment_Totals >= MerchandizeTotalPrice && !Remaining && !!Totals_GiftcardPaymentInstruments_Amount || !!Totals_OtherPaymentInstruments_Amount || (!!Totals_GiftcardPaymentInstruments_Amount && !!Totals_OtherPaymentInstruments_Amount)

  if (isMixablePaymentInstruments()) {
    //enableMixedpayments();
    if (getGiftcardError() === 'balance') {
      enableMixedpayments();
    } else {
      if (Payment_Incomplete_with_GC || Payment_Complete) {
        enableMixedpayments();
      } else {
        enableMixedpayments(true);
      }
    }
  } else {
    if (Payment_Complete) {
      disableOtherPayments();
    } else {
      enableMixedpayments(true);
    }
  }
  
  if (thereAreGiftcardOnCart()) {
    /*
    if (getTotals_OtherPaymentInstruments_Amount()) {
      disableOtherPayments();
    }
*/
    if (fromTrigger) {
      $giftcardTrigger.trigger('click');
    }
  }

}

function handleGifcardComponent() {

  if ($Add_Button.length > 0) {
    $Add_Button.on('click', function (e) {
      if (validateGiftCard()) {
        window.$.spinner().start();
        const submitURL = document.querySelector('input[name="js-giftcard__submit-url"]').value;
        const giftcardCard = $(e.target).closest('.giftcard-container');
        const giftcardNo = giftcardCard.data('serial');
        $('.paymentMethod.giftcard').find('alert').remove();

        $.ajax({
          url: submitURL,
          method: 'post',
          data: { giftcardNo },
          success: function (data) {
            if (data.success) {
              giftcardCard.addClass('added');
            } else {
              if (data.cartError && data.redirectUrl) {
                window.location.href = data.redirectUrl;
              }
              if (data.giftcardError === 'balance' && data.mixablePaymentInstruments) {
                giftcardCard.addClass('added');
              } else {
                $(e.target).removeAttr('checked');
              }
            }

            displayMessage(data.Mixed_Payments_Status__Messages);
            
            Update_AttributeData({
              trigger__Refresh_GiftCards: true,
              giftcardnumberonsession: data.giftcardNumber_On_Session,
              mixablepaymentinstruments: data.mixablePaymentInstruments,
              remaining: data.remaining,
              giftcarderror: data.giftcardError,
              totalsgiftcardpaymentinstrumentsamount: data.totals_GiftcardPaymentInstruments_Amount,
              totalsotherpaymentinstrumentsamount: data.totals_OtherPaymentInstruments_Amount,
            })

            $paymentMethodContainer.attr('data-giftcardnumberonsession', data.giftcardNumber_On_Session);

            window.$.spinner().stop();
          },
        });
      }
    }.bind(this))
  }

  if ($Remove_Button.length > 0) {
    $Remove_Button.on('click', function (e) {
      window.$.spinner().start();
      const RemoveURL = document.querySelector('input[name="js-giftcard__remove-url"]').value;
      const giftcardCard = $(e.target).closest('.giftcard-container');
      const giftcardNo = giftcardCard.data('serial');
      $.ajax({
        url: RemoveURL,
        method: 'post',
        data: { giftcardNo },
        success: function (data) {
          if (data.success) {
            giftcardCard.removeClass('added');
          }
          
          displayMessage(data.checkGiftcardsOnCart.Mixed_Payments_Status__Messages);
            
          Update_AttributeData({
            trigger__Refresh_GiftCards: true,
            giftcardnumberonsession: data.giftcardNumber_On_Session,
            mixablepaymentinstruments: data.mixablePaymentInstruments,
            remaining: data.checkGiftcardsOnCart.remaining,
            giftcarderror: data.checkGiftcardsOnCart.giftcardError,
            totalsgiftcardpaymentinstrumentsamount: data.checkGiftcardsOnCart.totals_GiftcardPaymentInstruments_Amount,
            totalsotherpaymentinstrumentsamount: data.checkGiftcardsOnCart.totals_OtherPaymentInstruments_Amount,
          })

          window.$.spinner().stop();
        }
      })
    })
  }

  if ($giftcardTrigger.length > 0) {
    $giftcardTrigger.on('change', function (e) {
      if ($(e.target).prop('checked')) {
        Active_GiftCertificate_PaymentMethod()
      } else {
        Active_FirstOther_PaymentMethod();
        $('[name="payment-giftcard"]').prop('checked', false);
        $('.giftcard-container').find('.alert').remove();
        $('#paymentMethodsList .paymentMethod').removeClass('disabled');
        $('.credit-card-selection-new .paymentMethod:not(.giftcard):not(.giftcard-container)').removeClass('disabled');
        RemoveAllGiftCardOnCart();
      }
      $(this).closest('.paymentMethod').find('ul').toggleClass('d-none');
    });
  }

  Refresh_PaymentMethods()

  $('body').on('adyen:createShowConfirmationForm', function() {
    Refresh_PaymentMethods(true)
  })

  $('body').on('checkout:updateCheckoutView', function () {
    setTimeout(() => Refresh_PaymentMethods(), 1000)
  })
}

function giftcardProduct() {
  $('body').on('click', '.js-amount-button', function (e) {
    e.preventDefault();
    $('.js-amount-button').removeClass('selected');
    $(this).addClass('selected');
    let $amountInput = $('input[name=dwfrm_giftcert_purchase_amount]');
    $amountInput.val($(this).data('value'));
  });

  $('body').on('change', '.recipient-select', function (e) {
    e.preventDefault();
    $('.recipient-info').addClass('d-none');
    $('.recipient-info').find('input').val('');

    if ($(this).val() === 'gift') {
      $('.recipient-info').removeClass('d-none');
      $('input[name="dwfrm_giftcert_purchase_from"]').attr('required', 'required');
      $('input[name="dwfrm_giftcert_purchase_recipient"]').attr('required', 'required');
    } else {
      $('input[name="dwfrm_giftcert_purchase_from"]').removeAttr('required');
      $('input[name="dwfrm_giftcert_purchase_recipient"]').removeAttr('required');
    }
  });
}

function RemoveAllGiftCardOnCart () {
  const RemoveAllGiftcardURL = $paymentMethodContainer.attr('data-removeallgiftcardoncart');

  window.$.spinner().start();

  $.ajax({
    url: RemoveAllGiftcardURL,
    method: 'post',
    success: function (data) {
      
      displayMessage(data.checkGiftcardsOnCart.Mixed_Payments_Status__Messages);
        
      Update_AttributeData({
        trigger__Refresh_GiftCards: true,
        giftcardnumberonsession: data.giftcardNumber_On_Session,
        mixablepaymentinstruments: data.mixablePaymentInstruments,
        remaining: data.checkGiftcardsOnCart.remaining,
        giftcarderror: data.checkGiftcardsOnCart.giftcardError,
        totalsgiftcardpaymentinstrumentsamount: data.checkGiftcardsOnCart.totals_GiftcardPaymentInstruments_Amount,
        totalsotherpaymentinstrumentsamount: data.checkGiftcardsOnCart.totals_OtherPaymentInstruments_Amount,
      })

      window.$.spinner().stop();
    }
  })
}

function Active_GiftCertificate_PaymentMethod() {
  $('#rb_GIFT_CERTIFICATE').trigger('click');
}

function Active_FirstOther_PaymentMethod() {
  $('#paymentMethodsList').find('.paymentMethod').first().find('input[name=brandCode]').trigger('click');
}

function InitProductDetail () {
  giftcardProduct()
}

module.exports = {
  InitProductDetail: InitProductDetail,
  Refresh_GiftCards: Refresh_GiftCards,
  Refresh_PaymentMethods: Refresh_PaymentMethods,
  getGiftCardNumberOnSession: getGiftCardNumberOnSession,
  setGiftCardNumberOnSession: setGiftCardNumberOnSession,
  setMixablePaymentInstruments: setMixablePaymentInstruments,
  isMixablePaymentInstruments: isMixablePaymentInstruments,
  Update_AttributeData: Update_AttributeData,
  handleGifcardComponent: handleGifcardComponent,
  giftcardProduct: giftcardProduct
};
